import $ from '@rover/globals/jquery';

function init() {
  /**
   * Ajax support for carousel images.
   * Whenever a carousel slides, look for images in the
   * next slide that need to be loaded asynchronously.
   */
  $(document).on('slide.bs.carousel', '[data-ride="carousel"]', e => {
    // Find the images in the the new slide that need loading
    let srcAttrName = 'data-src',
      loadingClass = 'rover-loading',
      $newSlide = $(e.relatedTarget),
      $imagesToProcess = $newSlide.find(`img[${srcAttrName}]`);

    $imagesToProcess.each(function() {
      // Find the image source that needs to be loaded
      let $img = $(this),
        newSrc = $img.attr(srcAttrName),
        $tmpImg = $('<img>');

      // Define behavior for when the image is finished loading
      $tmpImg.load(() => {
        $img.removeAttr(srcAttrName);
        $img.attr('src', newSrc);
        $img.unwrap();
        $newSlide.trigger('loaded');
      });

      // Update UI to reflect loading and start loading image
      $img.wrap(`<div class="img-responsive ${loadingClass}"></div>`);
      $tmpImg.attr('src', newSrc);
    });
  });
}

export default {
  init,
};



// WEBPACK FOOTER //
// ../utilities/carousels.js